module.exports = __webpack_public_path__ + "img/medical-symbol.fcce7f8d.svg";